{
  "title": "autobrr",
  "username": "用户名",
  "password": "密码",
  "confirmPassword": "确认密码",
  "createAccount": "创建账户",
  "rememberMe": "记住我",
  "forgotPassword": "忘记密码？",
  "forgotPasswordHelp": "可通过终端重置：",
  "signIn": "登录",
  "continueWith": "或使用以下方式继续",
  "openidConnect": "OpenID Connect",
  "errors": {
    "required": "必填",
    "usernameRequired": "用户名不能为空",
    "passwordRequired": "密码不能为空",
    "passwordsDoNotMatch": "两次输入的密码不一致",
    "generic": "发生错误",
    "oidcFailed": "OIDC 认证失败"
  }
}
